<template>
  <div v-if="tab" class="col-12 p-0">
    <div v-if="tab.games && tab.games.length" class="row games-list-row">
      <div
          v-for="(game, i) in tab.games"
          :key="'idx'+i"
          class="game-item-col col-6 col-sm-3 col-lg-2 px-0"
          :class="game.system === 'slotegrator' ? 'large-col' : 'narrow-col'">
        <GamePreview :game="game" :img="game.picture"  :gameIsFavorite="tab.icon == 'favorites'"></GamePreview>
      </div>
    </div>
    <div v-else>
      <h3 v-if="tab.searchText" class="text-center page-title no-results mt-4">
        По запросу
        <span class="no-results-search-text">&#171;{{ tab.searchText }}&#187;</span>
        ничего не найдено
        <span v-if="category"> в категории &#171;{{ category }}&#187;  </span>
        <span v-if="providers.length"> от выбранных провайдеров </span>
        !
      </h3>
      <h3 v-else class="text-center page-title no-results mt-4">
        <div v-if="!tab.games.length" class="row justify-content-center w-100 color-red mx-0 py-4">
          Список пуст
        </div>
      </h3>
    </div>
  </div>
</template>

<script>
import GamePreview from './GamePreview'

export default {
  name: 'GamesTab',
  props: ['tab', 'providers', 'category'],
  components: {
    GamePreview
  },
  computed: {
    isMobile() {
      return this.$_config.environment.mobile
    }
  }
}
</script>

<style scoped>
.games-list-row {
  margin: 0 -7px;
}
</style>
